module.exports = __webpack_public_path__ + "static/img/mainText.6b123650.png";